/**
 * 组件构建器 - 提供流式API创建组件
 */
export class ComponentBuilder {
    constructor(componentClass, ...args) {
        this.component = new componentClass(...args);
    }
    /**
     * 设置组件属性
     * @param property 属性名
     * @param value 属性值
     * @returns 组件构建器
     */
    set(property, value) {
        this.component[property] = value;
        return this;
    }
    /**
     * 使用配置函数设置组件
     * @param configurator 配置函数
     * @returns 组件构建器
     */
    configure(configurator) {
        configurator(this.component);
        return this;
    }
    /**
     * 条件性设置属性
     * @param condition 条件
     * @param property 属性名
     * @param value 属性值
     * @returns 组件构建器
     */
    setIf(condition, property, value) {
        if (condition) {
            this.component[property] = value;
        }
        return this;
    }
    /**
     * 构建并返回组件
     * @returns 构建的组件
     */
    build() {
        return this.component;
    }
}
//# sourceMappingURL=ComponentBuilder.js.map